import campaignNamesForCustomer from 'main/campaignNamesAndDesc'
import { formatNumberAsThousands } from 'utils/priceHelpers'

import styles from './SegmentsChart.module.scss'

const campaignNames = {
  ...campaignNamesForCustomer,
  OTACheckedOutReview: 'OTA Review',
  OTAAfterVisit: 'OTA After last visit',
  OTACancelled: 'OTA Cancelled',
  OTAJustBooked: 'OTA Just booked',
  OTALost3Months: 'OTA Lost 3 months',
  OTALost6Months: 'OTA Lost 6 months',
  OTALost9Months: 'OTA Lost 9 months',
  OTALost12Months: 'OTA Lost 12 months',
  OTALost15Months: 'OTA Lost 15 months',
  OTALost15MonthsPlus: 'OTA Lost 15 months plus',
  OTANoShow: 'OTA No show',
  SalesAgentVirtual: 'Sales agent',
  TextBlast: 'Text blast',
  Custom: 'Text blast'
}

const colors = [
  '#0EA5E9',
  '#14B8A6',
  '#06B6D4',
  '#22C55E',
  '#10B981',
  '#84CC16',
  '#EC4899',
  '#7CBFEB',
  '#85CBC1',
  '#82CADE',
  '#8CD496',
  '#86CBAA',
  '#B4D97B',
  '#E789B6'
]

const minWidth = 25
const maxWidth = 120

function getBarWidth(percentage) {
  return ((minWidth + percentage) * maxWidth * 1.1) / 100
}

const SegmentsChart = ({ barData }) => {
  return (
    <div className={styles.bars}>
      {barData
        .filter(c => c.count > 0)
        .map((campaign, index) => (
          <div className={styles.barHolder} key={index}>
            <div
              className={styles.bar}
              style={{
                backgroundColor: colors[index] || '#ccc',
                width: `${getBarWidth(campaign.percentage)}%`
              }}
            >
              {campaignNames[campaign.name] || campaign.name}
            </div>
            <span className={styles.countHolder}>
              {formatNumberAsThousands(campaign.count)}
            </span>
          </div>
        ))}
    </div>
  )
}

export default SegmentsChart
